// extracted by mini-css-extract-plugin
export default {"title":"style_title__dBKxn","rating":"style_rating__Aw0Wb","rating_container":"style_rating_container__K-7cO","overview":"style_overview__qoEZ5"};